<template>
    <div>
        <sparator v-show="showSparatorButton"></sparator>
        <div class="relative overflow-hidden">
            <picture class="z-0 w-full">
                <source
                    media="(max-width: 768px)"
                    srcset="storage/pages/donaturs-list/bg-landing-page-mobile.jpg"
                />
                <img
                    src="storage/pages/donaturs-list/bg-landing-page.jpg"
                    alt=""
                    class="w-full"
                />
            </picture>
            <div
                class="absolute top-0 left-0 z-10 flex items-center w-full h-full md:items-start md:pt-200"
            >
                <div
                    class="flex items-center justify-end w-full mx-150 md:mx-50 md:justify-center "
                >
                    <div
                        class="font-semibold text-black text-40 pr-400 md:pr-0"
                    >
                        Donasi <span class="text-5xl text-green-500">.</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="o">
            <div class="mx-150 md:mx-50 py-150">
                <div class="font-semibold leading-tight text-60 mb-100">
                    Terima Kasih Untuk Keinginan <br class="md:hidden" />Anda
                    Berkontribusi Secara Financial <br class="md:hidden" />Dalam
                    Misi Kami<span :class="this.$css.titleGreen">.</span>
                </div>
                <div class="flex mb-60">
                    <inertia-link
                        preserve-scroll
                        replace
                        :href="
                            route('donate.index', {
                                type: 'informasi-donasi'
                            })
                        "
                        class="mr-40 font-semibold text-center border-2 py-35 text-20 w-400"
                        :class="
                            type === null || type === 'informasi-donasi'
                                ? 'border-green-500 text-green-500'
                                : 'border-gray-500 text-gray-500'
                        "
                        >INFORMASI DONASI</inertia-link
                    >
                    <inertia-link
                        preserve-scroll
                        replace
                        :href="route('donate.index', { type: 'beri-donasi' })"
                        class="font-semibold text-center text-gray-500 border-2 py-35 text-20 w-400"
                        :class="
                            type === 'beri-donasi'
                                ? 'border-green-500 text-green-500'
                                : 'border-gray-500 text-gray-500'
                        "
                        >BERI DONASI</inertia-link
                    >
                </div>
                <div v-if="type === null || type === 'informasi-donasi'">
                    <div class="mb-150">
                        <div class="font-semibold text-60 mb-60 ">
                            Pilihan Donasi<span :class="this.$css.titleGreen"
                                >.</span
                            >
                        </div>
                        <div class="text-25 mb-60">
                            Ada beberapa cara Anda bisa memberikan donasi untuk
                            Tanam Benih Foundation.
                        </div>
                        <div class="flex -mx-40 md:-mx-0 md:flex-col">
                            <div
                                class="flex-1 mx-40 border-2 border-gray-500 md:mx-0 md:my-40 p-60"
                            >
                                <!-- <div
                                    class="font-bold leading-none text-150 mb-30"
                                >
                                    01<span :class="this.$css.titleGreen"
                                        >.</span
                                    >
                                </div> -->
                                <div class="font-semibold text-50 md:text-40">
                                    Donasi 1x<span :class="this.$css.titleGreen"
                                        >.</span
                                    >
                                </div>
                            </div>
                            <!-- <div class="flex-1 mx-40 border-2 border-gray-500 md:mx-0 md:my-40 p-60">
                                <div class="font-bold leading-none text-150 mb-30">02<span :class="this.$css.titleGreen">.</span></div>
                                <div class="font-semibold text-50 md:text-40">Donasi Rutin - Bulanan<span :class="this.$css.titleGreen">.</span></div>
                            </div> -->
                        </div>
                    </div>
                    <div class="mb-150">
                        <div class="font-semibold leading-none text-60 mb-60 ">
                            Jumlah Donasi<span :class="this.$css.titleGreen"
                                >.</span
                            >
                        </div>
                        <div class="text-25 mb-35">
                            Anda bebas menentukan jumlah donasi berapapun juga.
                            <!-- , dimulai dari Rp 50,000 -->
                        </div>
                    </div>
                    <div class="mb-150">
                        <div class="font-semibold leading-none text-60 mb-60 ">
                            Nama Donatur<span :class="this.$css.titleGreen"
                                >.</span
                            >
                        </div>
                        <div class="text-25 mb-35">
                            Cantumkan nama Anda sebagai donatur agar dapat kami
                            tampilkan di halaman “DONATUR” di website kami
                            nanti. Beri kami 4 x 24 jam sejak tanggal donasi
                            Anda untuk menampilkannya di halaman web atau sosial
                            media kami.<br /><br />Namun jika Anda tidak ingin
                            nama Anda tercantum, Anda tidak perlu menulis nama
                            atau cukup tulisan “ANONIM” pada kolom “NAMA
                            DONATUR”.
                        </div>
                    </div>
                    <div class="mb-150">
                        <div class="font-semibold leading-none text-60 mb-60 ">
                            Pemakaian Hasil Donasi<span
                                :class="this.$css.titleGreen"
                                >.</span
                            >
                        </div>
                        <div class="text-25 mb-35">
                            Tanam Benih Foundation adalah Organisasi Nirbala
                            (non-profit), sehingga 100% hasil donasi akan
                            digunakan untuk biaya operasional, produksi maupun
                            keperluan yayasan untuk memperbaiki dan memperluas
                            jangkauan misi kami untuk membantu para orang tua
                            menjadi lebih baik dalam mendidik dan mengasuh
                            anak-anaknya.
                        </div>
                    </div>
                    <div class="mt-40 text-left">
                        <inertia-link
                            @click="toggleShowButton"
                            :href="
                                route('donate.index', {
                                    type: 'beri-donasi'
                                })
                            "
                            :class="this.$css.button"
                            >BERI DONASI</inertia-link
                        >
                    </div>
                </div>
                <div v-if="type === 'beri-donasi'">
                    <div class="border-2 border-gray-500 p-60">
                        <div class="font-semibold text-60 mb-50">
                            Beri Donasi<span :class="this.$css.titleGreen"
                                >.</span
                            >
                        </div>
                        <!-- <div class="text-30 mb-30">
                            Setiap kelipatan Rp 100,000, Anda otomatis masuk
                            dalam daftar VIP donatur kami selama 1 bulan. VIP
                            donatur kami mendapatkan 10 video parenting
                            eksklusif setiap bulan via WhatsApp. Video-video
                            parenting ini tidak ditayangkan di sosial media
                            Tanam Benih.
                        </div> -->
                        <div class="text-30 mb-50">
                            Silakan masukkan nilai donasi yang Anda ingin
                            berikan di bawah ini. Metode pembayaran bisa Anda
                            pilih di halaman berikutnya.
                        </div>
                        <div class="flex w-7/12 md:w-full">
                            <!-- <div class="w-1/12 text-30 mt-25 md:hidden">Rp</div> -->
                            <TextInput
                                v-model="form.donation_daily"
                                :errors="$page.errors.donation"
                                class="w-11/12 md:w-full"
                                type="money"
                            />
                            <!-- placeholder="Minimal Rp 50,000" -->
                        </div>
                    </div>
                    <div
                        class="relative flex items-center justify-center my-80"
                    >
                        <div
                            class="absolute top-0 left-0 z-0 flex items-center justify-center w-full h-full"
                        >
                            <div class="w-full h-2 bg-gray-500 "></div>
                        </div>
                        <!-- <div
                            class="relative z-10 font-bold text-gray-800 bg-white px-25 text-60"
                        >
                            Atau
                        </div> -->
                    </div>
                    <!-- <div class="border-2 border-gray-500 p-60 mb-150">
                        <div class="font-semibold text-60 mb-60">
                            Donasi Otomatis Bulanan<span
                                :class="this.$css.titleGreen"
                                >.</span
                            >
                        </div>
                        <div class="text-30 mb-50">
                            Jika Anda ingin berdonasi secara rutin otomatis
                            setiap bulan, masukkan nilai donasi per bulan kami
                            debet otomatis dari kartu kredit atau metode
                            pembayaran lainnya yang Anda pilih di halaman
                            berikutnya.
                        </div>
                        <div class="flex w-7/12 md:w-full">
                            <div class="w-1/12 text-30 mt-25 md:hidden">Rp</div>
                            <TextInput
                                v-model="form.donation_monthly"
                                :errors="$page.errors.donation_monthly"
                                class="w-11/12 md:w-full"
                                right-text="per bulan"
                                type="money"
                                placeholder="Minimal Rp 10,000,-"
                            />
                        </div>
                    </div> -->
                    <div>
                        <div class="font-semibold leading-none text-60 mb-60 ">
                            Data Donatur<span :class="this.$css.titleGreen"
                                >.</span
                            >
                        </div>
                        <div class="text-25 mb-35">
                            Silakan masukkan nama dan data Anda, atau tuliskan
                            “ANONIM” di kolom nama jika Anda tidak ingin nama
                            Anda dicantumkan dalam halaman “DAFTAR DONATUR” di
                            website kami.
                        </div>
                        <div class="w-7/12 md:w-full">
                            <TextInput
                                v-model="form.full_name"
                                :errors="$page.errors.full_name"
                                class="mb-40"
                                type="text"
                                placeholder="Nama Lengkap (atau ANONIM)"
                            />
                            <TextInput
                                v-model="form.email"
                                :errors="$page.errors.email"
                                class="mb-40"
                                type="text"
                                placeholder="Email"
                            />
                            <TextInput
                                v-model="form.phone_number"
                                :errors="$page.errors.phone_number"
                                class="mb-40"
                                left-text="+62"
                                type="phone"
                                placeholder="Nomor Handphone"
                            />
                            <div class="flex mt-6">
                                <label class="flex items-center text-25">
                                    <input
                                        type="checkbox"
                                        value="1"
                                        class="text-green-500 form-checkbox"
                                        v-model="form.check_terms"
                                        id="checkbox-terms "
                                    />
                                    <span
                                        class="ml-20"
                                        :class="
                                            $page.errors.check_terms
                                                ? 'text-red-500'
                                                : ''
                                        "
                                        for="checkbox-terms"
                                        >I agree to the
                                        <a
                                            :href="route('terms.index')"
                                            target="_blank"
                                            class="underline"
                                            >terms and conditions</a
                                        ></span
                                    >
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="mt-40 text-left">
                        <button
                            :class="this.$css.button"
                            class="md:w-full md:text-center md:py-25"
                            @click="
                                submit();
                                toggleShowButton();
                            "
                        >
                            BERI DONASI
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import Icon from "@/Shared/Icon";
import TextInput from "@/Shared/TextInput";
import Sparator from "../../../components/Sparator.vue";

export default {
    metaInfo() {
        return {
            title: this.head.title
        };
    },
    layout: Layout,
    components: {
        Icon,
        TextInput,
        Sparator
    },
    props: {
        head: Object,
        request: Object,
        type: String
    },
    watch: {
        "form.donation_daily"(newValue, oldValue) {
            // console.log(this.form.donation);
            this.form.donation_monthly = 0;
            if (newValue != 0) {
                this.form.donation_type = "daily";
                this.form.donation = newValue;
            }
            // console.log(this.form.donation);
        }
        // "form.donation_monthly"(newValue, oldValue) {
        //     this.form.donation_daily = 0;
        //     if (newValue != 0) {
        //         this.form.donation_type = "monthly";
        //         this.form.donation = newValue;
        //     }
        // }
    },
    data() {
        return {
            showSparatorButton: false,
            form: {
                full_name: this.request ? this.request.full_name : null,
                email: this.request ? this.request.email : null,
                phone_number: this.request ? this.request.phone_number : null,
                // donation_type: this.request ? this.request.donation_type : null,
                donation: this.request ? this.request.donation : 100000,
                // donation_monthly: this.request
                //     ? this.request.donation_monthly
                //     : 0,
                donation_daily: this.request ? this.request.donation : 100000,
                check_terms: this.request ? this.request.check_terms : 0
            }
        };
    },

    methods: {
        toggleShowButton() {
            this.showSparatorButton = true;
        },
        submit() {
            this.$inertia
                .post(this.route("donate.validation"), this.form)
                .then(() => {});
        }
    },
    mounted() {}
};
</script>
